module.exports = __webpack_public_path__ + "static/desktop/img/template-love.3862c4b5.jpeg";